export default {
  en: {
    title: 'Log in to your account',
    email: 'Email Address',
    password: 'Password',
    login: 'Log in',
    loginSSO: 'Enterprise Sign-In (SSO)',
    forgot: 'Forgot Password?',
    remember: 'Remember me',
    forgotTitle: 'Reset password',
    errors: {
      email: 'Please enter your email',
      password: 'Please enter your password',
      incorrect: 'Please check your email or password.',
      subscriptions: 'You don\'t have an active subscriptions, please contact with us.',
      global: 'Server have a bad day, please try again.',
      level: 'Your account is of agent, please login in to console. Redirecting to your panel in 10 seconds.',
      terms: 'You must accept the terms and conditions, in order to log in',
      attempts: 'You have exceeded the attempt limit when logging in',
      session: 'The session has expired, please log in again.',
      ip: 'You are not authorized to connect using the current IP address',
      '2fa': 'The 2FA code expired, try with a new one',
    },
    correct: 'Log in successful',
    logout: 'Session was closed successful',
    terms: 'I accept',
    terms2: 'terms and conditions',
  },
  es: {
    title: 'Ingrese a su cuenta',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    loginSSO: 'Inicio de sesión empresarial (SSO)',
    forgot: 'Olvidé mi contraseña',
    remember: 'Recordar este equipo',
    forgotTitle: 'Restablecer contraseña',
    errors: {
      email: 'Ingrese su email',
      password: 'Ingrese su contraseña',
      incorrect: 'Revise su correo electrónico o contraseña.',
      subscriptions: 'No tiene suscripciones activas, contáctese con nosotros.',
      global: 'El servidor está pasando un mal día, inténtelo de nuevo.',
      level: 'Su cuenta es de agente, inicie sesión en la consola. Redireccionando a su panel en 10 segundos.',
      terms: 'Debe aceptar los terminos y condiciones, para poder iniciar sesión',
      attempts: 'Has excedido el límite de intentos de inicio de sesión',
      session: 'La sesión ha expirado, por favor inicia sesión nuevamente.',
      ip: 'No estás autorizado para conectarte usando la dirección IP actual',
      '2fa': 'El código 2FA ha expirado, intenta con uno nuevo'
    },
    correct: 'Ingreso correcto',
    logout: 'Sesión cerrada exitosamente',
    terms: 'Acepto los',
    terms2: 'términos y condiciones',
  },
  fr: {
    title: 'Connectez-vous à votre compte',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    login: 'Se connecter',
    loginSSO: 'Connexion entreprise (SSO)',
    forgot: 'Mot de passe oublié',
    remember: 'Se souvenir de cet appareil',
    forgotTitle: 'Réinitialiser le mot de passe',
    errors: {
      email: 'Veuillez entrer votre adresse e-mail',
      password: 'Veuillez entrer votre mot de passe',
      incorrect: 'Vérifiez votre e-mail ou votre mot de passe.',
      subscriptions: 'Vous n\'avez pas d\'abonnements actifs, veuillez nous contacter.',
      global: 'Le serveur rencontre un problème, veuillez réessayer.',
      level: 'Votre compte est un compte d\'agent, connectez-vous à la console. Redirection vers votre tableau de bord dans 10 secondes.',
      terms: 'Vous devez accepter les termes et conditions pour vous connecter.',
      attempts: 'Vous avez dépassé la limite de tentatives de connexion',
      session: 'La session a expiré, veuillez vous reconnecter.',
      ip: 'Vous n\'êtes pas autorisé à vous connecter avec l\'adresse IP actuelle',
      '2fa': 'Le code 2FA a expiré, essayez avec un nouveau code'
    },
    correct: 'Connexion réussie',
    logout: 'Déconnexion réussie',
    terms: 'J\'accepte les',
    terms2: 'termes et conditions',
}

};
